import {
  UserManager,
  UserManagerSettings,
  WebStorageStateStore,
} from "oidc-client";
import {
  LoginResponse,
  OIDCConfig,
  OIDCMetadataResponse,
} from "../store/oidc/types";
import { routes } from "../shared/constants";
import axios from "axios";

const KIPSU_OIDC_CONFIG = "KIPSU_APP_SETTINGS";

const createOpenIdConnectClient = async (
  config: OIDCConfig
): Promise<UserManager> => {
  let configResponse: OIDCMetadataResponse = {};
  if (config.configurationEndpoint !== "") {
    const response = await axios.get(config.configurationEndpoint);
    configResponse = response.data;
  }

  let settings: UserManagerSettings = {
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
    authority: config.url,
    client_id: config.clientId,
    redirect_uri: `${window.location.protocol}//${window.location.host}${routes.OIDC_CALLBACK}`,
    response_type: "code",
    scope:
      "openid profile email" +
      (config.customScopes.length > 0
        ? ` ${config.customScopes.join(" ")}`
        : ""),
    post_logout_redirect_uri: `${window.location.protocol}//${window.location.host}`,
    filterProtocolClaims: true,
    metadata: {
      issuer: configResponse.issuer ? configResponse.issuer : config.url + "/",
      authorization_endpoint: configResponse.authorization_endpoint
        ? configResponse.authorization_endpoint
        : config.authorizationEndpoint,
      token_endpoint: configResponse.token_endpoint
        ? configResponse.token_endpoint
        : config.tokenEndpoint,
      userinfo_endpoint: configResponse.userinfo_endpoint
        ? configResponse.userinfo_endpoint
        : config.url + "/userinfo",
      end_session_endpoint: configResponse.end_session_endpoint
        ? configResponse.end_session_endpoint
        : config.url + "/v2/logout",
      jwks_uri: configResponse.jwks_uri
        ? configResponse.jwks_uri
        : config.jwksEndpoint,
    },
  };

  localStorage.setItem(KIPSU_OIDC_CONFIG, JSON.stringify(config));
  return new UserManager(settings);
};

export const signInRedirect = async (config: OIDCConfig): Promise<any> => {
  if (config.isSaml) {
    window.location.href = config.url;
  } else {
    return (await createOpenIdConnectClient(config))
      .signinRedirect()
      .catch((reason) => {
        console.error("Redirect failed", reason);
      });
  }
};

export const loginListener = async (): Promise<LoginResponse> => {
  let config = localStorage.getItem(KIPSU_OIDC_CONFIG);
  if (!config) {
    return new Promise((res, rej) => rej());
  }
  const parsedConfig = JSON.parse(config);
  if (!parsedConfig) {
    return new Promise((res, rej) => rej());
  }

  return (
    await createOpenIdConnectClient(parsedConfig)
  ).signinRedirectCallback();
};
